module.exports = __webpack_public_path__ + "img/sp_foot_ico03.17206d04.svg";